'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletType = void 0;
var WalletType;
(function (WalletType) {
    WalletType["MAIN"] = "main";
    WalletType["BONUS"] = "bonus";
    WalletType["LOCKED"] = "locked";
    WalletType["SWEEPSTAKES"] = "sweepstakes";
})(WalletType = exports.WalletType || (exports.WalletType = {}));
